import React, { useEffect, useState } from "react";
import Header from "../../../CustomComponents/Header/Header";
import Footer from "../../../CustomComponents/Footer/Footer";
import { textDateFormatter } from "../../../utils/utils";
import NoDataFound from "../../../CustomComponents/NoDataFound/NoDataFound";
import Loader from "../../../CustomComponents/Loader/Loader";
import VendorHeader from "../../../CustomComponents/Property/VendorHeader/VendorHeader";
import AgentSideBar from "../AgentSideBar/AgentSideBar";
import AgentProfile from "../AgentProfile/AgentProfile";
import AgentHeader from "../AgentHeader/AgentHeader";

const AgentAdvanceLogs = () => {
  const [advanceLogs, setAdvanceLogs] = useState([]);
  const [loader, setLoader] = useState(false);
  const userDetails = JSON.parse(localStorage.getItem("userDetails"));
  // console.log(userDetails);

  const fetchAdvancePayments = (id) => {
    setLoader(true);
    const myHeaders = new Headers();
    myHeaders.append("Accept", "application/json");
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${localStorage.getItem("token")}`);
   
    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      redirect: "follow"
    };

    fetch(
      `${process.env.REACT_APP_APP_URL}/api/v1/agents/advanced-logs/${id}`,
      requestOptions
    )
      .then((response) => response.json()) // Parse the response as JSON
      .then((result) => {
        if (result.success) {
          setAdvanceLogs(result.data);
          setLoader(false); // Hide loader after request completion
        } else {
          setLoader(false);
        }
      })
      .catch((error) => console.error("Error fetching single rate:", error));
  };
  useEffect(() => {
    if (userDetails?.id) {
      fetchAdvancePayments(userDetails?.id);
    }
  }, [userDetails?.id]);

  return (
    <>
      <AgentHeader showSelectProperty={true} />
      <div className="sidebar_main_div">
        <AgentSideBar />
        <section className="w-full table-data">
          <div>
            <div className="overflow_x_scroll_y_hidden">
              {loader ? (
                <Loader size="4em" color="#016937" />
              ) : (
                <>
                  <h4>Advance Payments</h4>
                  {/* <AgentProfile /> */}

                  {advanceLogs?.length > 0 ? <>  <div className="overflow_x_scroll_y_hidden">
                    <table className="inventory_table">
                      <tr style={{ borderBottom: "1px solid #cccccc96" }}>
                        <th> S.No</th>
                        <th> Date</th>
                        <th>Booking ID</th>
                        {/* <th>Total Credits</th> */}
                        <th>Credits Amount</th>
                        <th>Debit Amount</th>
                        <th>Transaction Type</th>
                        <th>Used</th>
                        <th>Available</th>
                        <th>Status</th>
                      </tr>

                      {advanceLogs?.length > 0 ? (
                        <>
                          {loader ? (
                            <Loader size="4em" color="#016937" />
                          ) : (
                            <>
                              {advanceLogs?.map((item, index) => {
                                return (
                                  <tr>
                                    <td>{index + 1}</td>
                                    <td>
                                      {textDateFormatter(item?.date)}
                                    </td>
                                    <td>{item?.booking_id ? item?.booking_id : "N/A"}</td>
                                    {/* <td>{item?.total_credits}</td> */}
                                    <td>{item?.credit_amount}</td>
                                    <td>{item?.debit_amount}</td>
                                    <td>{item?.transaction_type}</td>
                                    <td>{item?.used_advance_amount}</td>
                                    <td>{item?.total_advance_amount}</td>
                                    <td>{item?.status ? item?.status : "N/A"}</td>
                                  </tr>
                                );
                              })}
                            </>
                          )}
                        </>
                      ) : (
                        <>
                          <tr>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td className="text-end p_20">No Data Found</td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                          </tr>
                        </>
                      )}
                    </table>
                  </div></> : <><NoDataFound /></>}
                
                </>
              )}
            </div>
          </div>
        </section>
      </div>
      <Footer />
    </>
  );
};

export default AgentAdvanceLogs;
